import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OrdersService } from '../../services/orders.service';
import { Order } from '../../../dto/order';
import { CountryService } from '../../../services';
import { ProductService } from '../../services/product.service';
import { Product } from '../../../dto/product';
import { Country } from '../../../dto/country';

@Component({
  selector: 'app-order-edit',
  templateUrl: './order-edit.component.html',
  styleUrls: ['./order-edit.component.css']
})
export class OrderEditComponent implements OnInit {
  order: Order;
  products: Product[];
  countries: Country[];
  orderForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private ordersService: OrdersService,
    private countryService: CountryService,
    private productService: ProductService,
    private formBuilder: FormBuilder,
    private location: Location,
  ) { }

  ngOnInit() {
    this.productService.getAll().subscribe(result => {
      this.products = result.data;
    });
    this.countryService.getMany().subscribe(result => {
      this.countries = result.data;
    });


    const id = this.route.snapshot.paramMap.get('id');
    this.ordersService.get(parseInt(id)).subscribe(result => {
      this.initForm(result);
    });
  }

  initForm(order: Order) {
    this.orderForm = this.formBuilder.group(order);
  }

  returnBack() {
    this.location.back();
  }

  onSubmit() {
    this.ordersService.update(this.orderForm.value)
      .subscribe(res => this.returnBack());
  }
}
